import type {
	InstagramConnection,
	SquareConnection,
} from './userSettingsTypes';

export type OAuthProvider = 'instagram' | 'square';

export type OAuthSuccessMessage = {
	type: 'oauth_result';
	provider: OAuthProvider;
	status: 'success';
	connectionUpdated: true;
	connectionData?: InstagramConnection | SquareConnection;
};

/** Which part of the Instagram connect flow failed. */
export type InstagramConnectFailureStep =
	| 'oauth_redirect'
	| 'token_exchange'
	| 'fetch_pages'
	| 'no_instagram_pages'
	| 'page_not_found'
	| 'page_missing_instagram'
	| 'connection_build';

/**
 * Extra facts about a failure. Keys are snake_case because the chat agent reads
 * them out of chat state and renders them as they arrive. Known keys: status,
 * meta_code, meta_subcode, meta_type, fbtrace_id, meta_message, page_count,
 * pages_with_connected_instagram, pages_with_instagram_business_account.
 */
export type InstagramConnectFailureDetails = Record<string, string | number>;

export type OAuthErrorMessage = {
	type: 'oauth_result';
	provider: OAuthProvider;
	status: 'error';
	code: string;
	message: string;
	details?: InstagramConnectFailureDetails;
};

export type OAuthCloseBlockedMessage = {
	type: 'oauth_close_blocked';
	provider: OAuthProvider;
	message: string;
};

export type OAuthResultMessage = OAuthSuccessMessage | OAuthErrorMessage;

export const OAUTH_MESSAGE_TYPE = 'oauth_result';
export const OAUTH_CLOSE_BLOCKED_MESSAGE_TYPE = 'oauth_close_blocked';
